module.exports = __webpack_public_path__ + "static/media/sales-turnover.da5d8ae5.svg";